"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyWordFlashcard = exports.AnyWordFlashcardSchema = exports.isWordToAnyFlashcard = exports.WordToAnyFlashcardSchema = exports.isPicToWordFlashcard = exports.PicToWordFlashcardSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const flashcard_back_types_1 = require("./flashcard_back_types");
const flashcard_common_types_1 = require("./flashcard_common_types");
const word_flashcard_type_types_1 = require("./word_flashcard_type_types");
exports.PicToWordFlashcardSchema = flashcard_common_types_1.FlashcardBaseSchema.extend(flashcard_common_types_1.WordFlashcardAttributesSchema.shape).extend({
    type: word_flashcard_type_types_1.PicToWordFlashcardTypeSchema,
});
exports.isPicToWordFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.PicToWordFlashcardSchema);
exports.WordToAnyFlashcardSchema = flashcard_common_types_1.FlashcardWithoutPicturesBaseSchema.extend({
    backs: flashcard_back_types_1.AnyFlashcardBackSchema.array(),
    type: word_flashcard_type_types_1.WordToAnyFlashcardTypeSchema,
    word_audio_url: zod_1.z.string().optional(),
    word_ipa_txt: zod_1.z.string().optional(),
    word_known_txt: zod_1.z.string().optional(),
    word_learn_gender: zod_1.z.string().optional(),
    word_learn_id: zod_1.z.string(),
    word_learn_reading: zod_1.z.string().optional(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_diacritics: zod_1.z.string().optional(),
});
exports.isWordToAnyFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.WordToAnyFlashcardSchema);
exports.AnyWordFlashcardSchema = zod_1.z.union([
    exports.PicToWordFlashcardSchema,
    exports.WordToAnyFlashcardSchema,
]);
exports.isAnyWordFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AnyWordFlashcardSchema);
//# sourceMappingURL=word_flashcard_types.js.map